module.exports = __webpack_public_path__ + "static/media/sapmle_company_light_logo.319dc98b.svg";